const ScopeComponent = (Component) => {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"0b14d26"}`, "");
  });
};
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-DxrG1ptt.mjs.map
